import { CustomSnackbarService } from './../services/custom-snackbar-service.service';
import { BirthDateValidator } from './utils/validators/birthDateValidator';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { ConfigService } from '@services/webFeeder/config.service';
import { FullNameValidator } from './utils/validators/fullNameValidator';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog } from '@angular/material/dialog';
import { RegisterService } from './register.service';
import { PhoneValidator } from './utils/validators/phoneValidator';
import { Component, OnInit, ViewChild, ViewEncapsulation, ViewContainerRef, Type } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CpfCnpjValidator } from './utils/validators/cpfCnpjValidator';
import { Constants, SINACOR_ERROR_REGISTER_MESSAGE, SINACOR_ERROR_REGISTER_MESSAGE_DESCRIPTION_DEFAULT, SINACOR_ERROR_REGISTER_MESSAGE_TITLE_DEFAULT } from '@utils/constants';
import { AppUtils } from '@utils/app.utils';
import { StepEnum, ProgressBarMaxEnum, TypeRegistration } from '@model/enum/register-types.enum';
import { ConfirmationModalComponent } from '@component/confirmation-modal/confirmation-modal.component';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RegisterComponent implements OnInit {

  @ViewChild('snackBar', { read: ViewContainerRef }) snackBarSlot: ViewContainerRef;

  registerTypesRadio = [
    {
      type: 1, title: 'Sem corretora',
      description: 'Você não precisa ter uma corretora para acessar o FAST TRADE. Preencha seus dados abaixo e garanta 7 dias de acesso gratuito.'
    },
    {
      type: 2, title: 'Vincular corretora',
      description: 'Ao vincular com uma corretora, você só poderá enviar ordens através desta corretora, mas você pode ter um preço melhor (checar valores com sua corretora).'
    },
  ];

  errorTypes = [
    {
      title: 'Oops, não foi possível criar a conta',
      description: `
      <p>
      Não foi possível criar a conta com os dados preenchidos. Tente novamente, ou caso essa conta já exista, tente recuperar a senha. Caso contrário, estamos disponíveis para auxiliá-lo através dos seguintes canais de atendimento:
      </p>
      <p class="text-left">
      <strong>Email:</strong> servicedesk@cedrotech.com<br>
      <strong>Telefone:</strong> +55 (11) 3014-0200<br>
      <strong>Whatsapp:</strong> +55 (34) 3239-0003
      </p>
      `,
      retryText: 'TENTAR NOVAMENTE'
    },
    {
      title: 'Dados incorretos',
      description: 'Não conseguimos localizar o dados vinculados na corretora selecionada. Verifique as informações e tente novamente.', retryText: 'REVISE SEUS DADOS'
    }
  ];
  countryStates = Constants.COUNTRY_STATES;
  underageError: string = Constants.UNDERAGE_REGISTER_MESSAGE;
  invalidDateError: string = Constants.INVALID_DATE_REGISTER_MESSAGE;
  stepEnum = StepEnum;
  currentStep = StepEnum.RegisterType;
  registerForm: FormGroup;
  selectedRegistrationType: any;
  registerGoToIdentity = this._configService.registerGoToIdentity();
  selectedRegistrationMessage: string;
  brokeragePartners = [];
  lottieConfig: { path: any; renderer: string; autoplay: boolean; loop: boolean; };
  loadingBrokers = false;
  loadingCep = false;
  showingError: boolean;
  errorTitle: string;
  errorDescription: string;
  errorRetryBtnText: string;
  progressBarColor = 'primary';
  progressBarMode: ProgressBarMode = 'determinate';
  progressBarValue = 50;
  brokerHasSinacor = true;
  whitelabel = this._configService.getConfigWhitelabel();
  isRanking: boolean;
  sinacorErrorTitle: string = SINACOR_ERROR_REGISTER_MESSAGE_TITLE_DEFAULT;
  sinacorErrorDescription: string = SINACOR_ERROR_REGISTER_MESSAGE_DESCRIPTION_DEFAULT;
  showFormIntegrator: boolean;
  selectedBroker: any;
  brokerInitParam = { value: null };
  dialog: MatDialog;

  passwordComplexyLength: boolean;
  passwordComplexySpecial: boolean;
  passwordComplexyNumber: boolean;
  passwordComplexyLetterUp: boolean;
  passwordComplexyLetterDown: boolean;
  passwordEqualConfirmation: boolean;
  oldPassword = '';
  oldConfirmation = '';
  optionsLottie: AnimationOptions = {
    path: Constants.LOADING_ANIMATION_URL,
  };

  constructor(
    private formBuilder: FormBuilder,
    public router: Router,
    private _route: ActivatedRoute,
    private registerService: RegisterService,
    private notificationsService: NotificationsService,
    private _configService: ConfigService,
    private _snackBar: CustomSnackbarService,
    dialog: MatDialog,
  ) {
    this.dialog = dialog;
  }

  ngOnInit() {
    AppUtils.orderObjectAsc(this.countryStates, 'name');
    this.buildForm();
    if (this.whitelabel.system.cod === WhitelabelEnum.RANKING) {
      this.isRanking = true;
    } else {
      this.isRanking = false;
    }
    this.lottieConfig = {
      path: Constants.LOADING_ANIMATION_URL,
      renderer: 'canvas',
      autoplay: true,
      loop: true
    };

    this.setDefaultErrorInfo();
  }

  disableAddres() {
    (<any>Object).values(this.registerForm.controls['address']['controls']).forEach((control, index) => {
      if (index != 0) {
        control.disable();
      } else {
        control.enable();
      }
    });
  }

  setDefaultErrorInfo() {
    this.errorTitle = this.errorTypes[0].title;
    this.errorDescription = this.errorTypes[0].description;
    this.errorRetryBtnText = this.errorTypes[0].retryText;
  }

  fillBrokerList() {
    this.loadingBrokers = true;
    this.registerService.getBrokerList().subscribe(res => {
      this.brokeragePartners = [];
      if (res && res.length > 0) {
        res.forEach(element => {
          if (element.broker !== 'F2L') {
            this.brokeragePartners.push(element);
          }
        });
      }
      this.showingError = this.brokeragePartners.length == 0;
      AppUtils.orderObjectAsc(this.brokeragePartners, 'description');
      if (!this.brokerInitParam || !this.brokerInitParam.value) {
        this.loadingBrokers = false;
      }
    }, () => {
      this.loadingBrokers = false;
      this.showingError = true;
    });
  }

  validatorPassword(value) {
    if (value) {
      if (new RegExp('^(?=.*[&?=#% ])').test(value)) {
        this.registerForm.controls['password'].patchValue({
          password: this.oldPassword,
          confirmation: this.registerForm.controls['password'].value.confirmation || '',
        });
      } else {
        this.complexyPassoword(value);
        this.oldPassword = value;
      }
    } else {
      this.passwordComplexyLength = false;
      this.passwordComplexyNumber = false;
      this.passwordComplexySpecial = false;
      this.passwordComplexyLetterUp = false;
      this.passwordComplexyLetterDown = false;
      this.oldPassword = '';
    }

    this.passwordEqualConfirmation = this.registerForm.controls['password'].value.confirmation !== '' &&
      this.registerForm.controls['password'].value.confirmation === this.registerForm.controls['password'].value.password;
  }

  validatorConfirmation(value) {
    if (value) {
      if (new RegExp('^(?=.*[&?=#% ])').test(value)) {
        this.registerForm.controls['password'].patchValue({
          password: this.registerForm.controls['password'].value.password || '',
          confirmation: this.oldConfirmation,
        });
      } else {
        this.oldConfirmation = value;
      }
    } else {
      this.oldPassword = '';
    }

    this.passwordEqualConfirmation = this.registerForm.controls['password'].value.confirmation !== '' &&
      this.registerForm.controls['password'].value.confirmation === this.registerForm.controls['password'].value.password;
  }

  complexyPassoword(value) {
    if (value && value !== '') {
      const passwordComplexyLengthTemp = new RegExp('^(?=.{8,})').test(value);
      const passwordComplexySpecialTemp = new RegExp('^(?=.*[#$^+=!*()@%&])').test(value);
      const passwordComplexyNumberTemp = new RegExp('^(?=.*[0-9])').test(value);
      const passwordComplexyLetterUpTemp = new RegExp('^(?=.*[A-Z])').test(value);
      const passwordComplexyLetterDownTemp = new RegExp('^(?=.*[a-z])').test(value);
      this.passwordComplexyLength = passwordComplexyLengthTemp ? true : false;
      this.passwordComplexySpecial = passwordComplexySpecialTemp ? true : false;
      this.passwordComplexyNumber = passwordComplexyNumberTemp ? true : false;
      this.passwordComplexyLetterUp = passwordComplexyLetterUpTemp ? true : false;
      this.passwordComplexyLetterDown = passwordComplexyLetterDownTemp ? true : false;
    }
  }

  buildForm() {
    this.registerForm = this.formBuilder.group({
      partner: this.formBuilder.group({
        broker: new FormControl(''),
        name: new FormControl(''),
        cpf: new FormControl(''),
        account: new FormControl(''),
        is_professional: new FormControl(false),
        acepted_term: new FormControl(false)
      }),
      profile: this.formBuilder.group({
        broker: new FormControl(''),
        name: new FormControl(''),
        cpf: new FormControl(''),
        email: new FormControl(''),
        phone: new FormControl(''),
        birth_date: new FormControl(''),
        is_professional: new FormControl(false)
      }),
      address: this.formBuilder.group({
        zip_code: new FormControl(''),
        address: new FormControl(''),
        number: new FormControl(''),
        neighborhood: new FormControl(''),
        city: new FormControl(''),
        state: new FormControl(''),
        acepted_term: new FormControl(false)
      }),
      password: this.formBuilder.group({
        password: new FormControl(''),
        confirmation: new FormControl('')
      })
    });
    this.getBrokerInit();
  }

  getBrokerInit() {
    this._route.queryParams.subscribe(params => {
      if (params['broker']) {
        this.loadingBrokers = true;
        this.brokerInitParam.value = params['broker'];
        this.selectType(this.registerTypesRadio[1].type);
      } else {
        this.selectType(this.registerTypesRadio[0].type);
      }
    });
  }

  resetProfile() {
    (<any>Object).values(this.registerForm.controls['profile']['controls']).forEach((control, index) => {
      control.reset();
    });
  }

  selectType(type, isMercBitcoin?) {
    this.registerForm.reset();
    this.resetProfile();
    this.brokerHasSinacor = true;
    this.selectedRegistrationType = type;
    this.selectedRegistrationMessage = this.registerTypesRadio.find(x => x.type === type).description;
    switch (type) {
      case 1:
        this.showFormIntegrator = false;
        this.currentStep = StepEnum.PersonalInformation;
        setTimeout(() => {
          if (document.getElementById('name')) {
            document.getElementById('name').focus();
          }
        }, 50);
        this.setValidations();
        break;
      case 2:
        this.fillBrokerList();
        if (!isMercBitcoin) {
          this.currentStep = StepEnum.PartnerBrokerage;
          this.showFormIntegrator = false;
        }
        this.setValidations();
        setTimeout(() => {
          if (this.brokerInitParam && this.brokerInitParam.value) {
            this.onBrokerChange(this.brokerInitParam);
          }
        }, 500);
        break;
    }
  }

  changePasswordVisibility(input: HTMLInputElement) {
    if (!input || !input.type) {
      return;
    }
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  setValidations() {
    switch (this.selectedRegistrationType) {
      case 1:
        this.setProfileRequired(true);
        this.setAddressRequired(true);
        this.setPartnerRequired(false);
        this.setPasswordRequired(this.registerGoToIdentity ? true : false);
        break;
      case 2:
        if (this.showFormIntegrator) {
          this.setProfileRequired(true);
          this.setAddressRequired(true);
          this.setPartnerRequired(false);
          this.setPasswordRequired(this.registerGoToIdentity ? true : false);
        } else {
          this.setPartnerRequired(true);
          this.setProfileRequired(false);
          this.setAddressRequired(false);
          this.setPasswordRequired(false);
        }
        break;
    }
  }

  setProfileRequired(isRequired) {
    const profileForm = this.registerForm.get('profile');
    const name = profileForm.get('name');
    const cpf = profileForm.get('cpf');
    const email = profileForm.get('email');
    const phone = profileForm.get('phone');
    const profile_is_professional = profileForm.get('is_professional');
    const broker = profileForm.get('broker');
    const birth_date = profileForm.get('birth_date');
    if (this.showFormIntegrator) {
      broker.setValidators([Validators.required]);
      broker.setValue(this.selectedBroker.broker);
    } else {
      broker.setValidators(null);
    }
    if (isRequired) {
      name.setValidators([Validators.required, FullNameValidator.validateName]);
      cpf.setValidators([Validators.required, CpfCnpjValidator.validateCPF]);
      email.setValidators([Validators.required, Validators.email]);
      phone.setValidators([PhoneValidator.validatePhone]);
      birth_date.setValidators([Validators.required, BirthDateValidator.validateAge]);
    } else {
      name.setValidators(null);
      cpf.setValidators(null);
      email.setValidators(null);
      phone.setValidators(null);
      birth_date.setValidators(null);
    }
    profile_is_professional.setValue(false);
    name.updateValueAndValidity();
    cpf.updateValueAndValidity();
    email.updateValueAndValidity();
    phone.updateValueAndValidity();
    profile_is_professional.updateValueAndValidity();
    broker.updateValueAndValidity();
  }

  setAddressRequired(isRequired) {
    const addressForm = this.registerForm.get('address');
    const zip_code = addressForm.get('zip_code');
    const address = addressForm.get('address');
    const neighborhood = addressForm.get('neighborhood');
    const city = addressForm.get('city');
    const state = addressForm.get('state');
    const acepted_term_address = addressForm.get('acepted_term');
    if (isRequired) {
      zip_code.setValidators([Validators.required, Validators.minLength(9)]);
      address.setValidators([Validators.required]);
      neighborhood.setValidators([Validators.required]);
      city.setValidators([Validators.required]);
      state.setValidators([Validators.required]);
      acepted_term_address.setValidators([Validators.required, Validators.requiredTrue]);
      acepted_term_address.setValue(false);
    } else {
      zip_code.setValidators(null);
      address.setValidators(null);
      neighborhood.setValidators(null);
      city.setValidators(null);
      state.setValidators(null);
      acepted_term_address.setValidators(null);
    }
    zip_code.updateValueAndValidity();
    address.updateValueAndValidity();
    neighborhood.updateValueAndValidity();
    city.updateValueAndValidity();
    state.updateValueAndValidity();
    acepted_term_address.updateValueAndValidity();
  }

  setPasswordRequired(isRequired) {
    const passwordForm = this.registerForm.get('password');
    const password = passwordForm.get('password');
    const confirmation = passwordForm.get('confirmation');

    if (isRequired) {
      password.setValidators([Validators.required]);
      confirmation.setValidators([Validators.required]);
      this.registerForm.setValidators(this.passwordConfirmValidation.bind(this));
    } else {
      password.setValidators(null);
      confirmation.setValidators(null);
    }
    password.updateValueAndValidity();
    confirmation.updateValueAndValidity();
  }

  get registerFormPasswordGroup(): FormGroup {
    return this.registerForm.controls['password'] as FormGroup
  }

  get registerFormGroupAddress(): FormGroup {
    return this.registerForm.controls['address'] as FormGroup
  }

  get registerFormProfileGroup(): FormGroup {
    return this.registerForm.controls['profile'] as FormGroup
  }

  get registerFormPartnerGroup(): FormGroup {
    return this.registerForm.controls['partner'] as FormGroup
  }

  passwordConfirmValidation() {
    const passwordForm = this.registerForm.get('password');
    const passwordValue = passwordForm.get('password').value;
    const confirmationValue = passwordForm.get('confirmation').value;
    if (
      passwordForm &&
      confirmationValue &&
      confirmationValue !== passwordValue
    ) {
      passwordForm.get('confirmation').setErrors({ invalid_confirmation: true });
    } else {
      passwordForm.get('confirmation').setErrors(null);
    }
  }

  setPartnerRequired(isRequired, brokerTemp?) {
    const partnerForm = this.registerForm.get('partner');
    const broker = partnerForm.get('broker');
    const name_partner = partnerForm.get('name');
    const cpf_partner = partnerForm.get('cpf');
    const account = partnerForm.get('account');
    const acepted_term_partner = partnerForm.get('acepted_term');
    const partner_is_professional = partnerForm.get('is_professional');
    if (isRequired) {
      broker.setValidators([Validators.required]);
      name_partner.setValidators([Validators.required, FullNameValidator.validateName]);
      cpf_partner.setValidators([Validators.required, CpfCnpjValidator.validateCPF]);
      account.setValidators([Validators.required]);
      acepted_term_partner.setValidators([Validators.required, Validators.requiredTrue]);
      acepted_term_partner.setValue(false);
    } else {
      broker.setValidators(null);
      name_partner.setValidators(null);
      cpf_partner.setValidators(null);
      account.setValidators(null);
      acepted_term_partner.setValidators(null);
    }
    if (brokerTemp && this.selectedBroker && this.selectedBroker.broker) {
      broker.setValue(this.selectedBroker.broker);
    }
    partner_is_professional.setValue(false);
    broker.updateValueAndValidity();
    name_partner.updateValueAndValidity();
    cpf_partner.updateValueAndValidity();
    account.updateValueAndValidity();
    acepted_term_partner.updateValueAndValidity();
    partner_is_professional.updateValueAndValidity();
  }

  goBack() {
    this.showingError = false;
    this.brokerInitParam.value = null;
    switch (this.currentStep) {
      case StepEnum.PartnerBrokerage:
      case StepEnum.PersonalInformation:
        this.buildForm();
        this.brokerHasSinacor = true;
        this.showFormIntegrator = false;
        this.currentStep = StepEnum.RegisterType;
        break;
      case StepEnum.Address:
        this.currentStep = StepEnum.PersonalInformation;
        setTimeout(() => {
          if (document.getElementById('name')) {
            document.getElementById('name').focus();
          }
        }, 50);
        break;
      case StepEnum.Password:
        this.currentStep = StepEnum.Address;
        setTimeout(() => {
          if (document.getElementById('zip_code')) {
            document.getElementById('zip_code').focus();
          }
        }, 50);
        break;
      case StepEnum.FinalLoading:
        if (this.selectedRegistrationType === TypeRegistration.Provider) {
          this.currentStep = StepEnum.PartnerBrokerage;
          break;
        } else {
          this.currentStep = StepEnum.PersonalInformation;
          break;
        }
    }
  }

  next() {
    switch (this.currentStep) {
      case StepEnum.PartnerBrokerage:
      case StepEnum.Password:
        this.submit();
        break;
      case StepEnum.Address:
        if (!this.registerGoToIdentity) {
          this.submit();
          break;
        }
        this.currentStep = StepEnum.Password;
        setTimeout(() => {
          if (document.getElementById('input-password')) {
            document.getElementById('input-password').focus();
          }
        }, 50);
        break;
      case StepEnum.PersonalInformation:
        this.currentStep = StepEnum.Address;
        setTimeout(() => {
          if (document.getElementById('zip_code')) {
            document.getElementById('zip_code').focus();
          }
        }, 50);
        break;
    }
  }

  callHelp() {
    window.open('https://plataformafasttrade.com.br/suporte/', '_blank');
  }

  getAddress() {
    let showModalCep = false;
    if (this.registerForm.controls['address']['controls']['zip_code'].valid) {
      this.loadingCep = true;
      this.registerService.getAddressByPostalCode(this.registerForm.controls['address']['controls']['zip_code'].value)
        .subscribe(response => {
          if (response && response.data) {
            (<any>Object).values(this.registerForm.controls['address']['controls']).forEach((control, index) => {
              if (index != 0 && control.value) {
                showModalCep = true;
              }
            });
            if (showModalCep) {
              const confirmDialog = this.dialog.open(ConfirmationModalComponent, {
                panelClass: Constants.NORMAL_MODAL,
                disableClose: true,
                width: '50%'
              });
              confirmDialog.componentInstance.title = Constants.CEP_FOUND_TITLE;
              confirmDialog.componentInstance.content = Constants.CEP_FOUND_MESSAGE_MODAL;
              confirmDialog.componentInstance.confirmText = 'USAR NOVOS VALORES';
              confirmDialog.componentInstance.cancelText = 'USAR VALORES ATUAIS';
              confirmDialog.afterClosed().subscribe(reload => {
                if (reload) {
                  this.fillAddressFromCEP(response.data);
                }
              });
            } else {
              this.fillAddressFromCEP(response.data);
            }
          } else if (response && response.error) {
            this.notificationsService.warn('', Constants.CEP_NOT_FOUND_MESSAGE);
          }
          this.loadingCep = false;
        }, () => {
          this.loadingCep = false;
          this.notificationsService.error('', Constants.CEP_NOT_FOUND_MESSAGE);
        });
    }
  }

  fillAddressFromCEP(data) {
    this.registerForm.controls['address'].patchValue({
      address: data.logradouro || '',
      neighborhood: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || '',
      number: '',
      acepted_term: ''
    });
    (<any>Object).values(this.registerForm.controls['address']['controls']).forEach((control, index) => {
      control.enable();
      control.markAsTouched();
    });
    if (!data.erro) {
      setTimeout(() => {
        if (document.getElementById('input-address')) {
          document.getElementById('input-address').focus();
        }
      }, 250);
    }
  }

  isFormValid() {
    switch (this.currentStep) {
      case StepEnum.PartnerBrokerage:
        return this.registerForm.controls['partner'].valid;
      case StepEnum.PersonalInformation:
        return this.registerForm.controls['profile'].valid;
      case StepEnum.Address:
        return this.registerForm.controls['address'].valid;
      case StepEnum.Password:
        if (this.passwordComplexyLength && this.passwordComplexyNumber && this.passwordComplexySpecial
          && this.passwordComplexyLetterUp && this.passwordComplexyLetterDown &&
          this.registerForm.controls['password'].value.confirmation === this.registerForm.controls['password'].value.password) {
          return this.registerForm.controls['password'].valid;
        } else {
          return false;
        }
      default:
        return false;
    }
  }

  parseToPost() {
    const name = this.selectedRegistrationType == TypeRegistration.Provider ? (this.showFormIntegrator ? this.registerForm.controls['profile']['controls']['name'].value : this.registerForm.controls['partner']['controls']['name'].value) : this.registerForm.controls['profile']['controls']['name'].value;
    const cpf = this.selectedRegistrationType == TypeRegistration.Provider ? (this.showFormIntegrator ? this.registerForm.controls['profile']['controls']['cpf'].value : this.registerForm.controls['partner']['controls']['cpf'].value) : this.registerForm.controls['profile']['controls']['cpf'].value;
    const account = this.registerForm.controls['partner']['controls']['account'].value;
    const professional = this.selectedRegistrationType == TypeRegistration.Provider ? (this.showFormIntegrator ? this.registerForm.controls['profile']['controls']['is_professional'].value : this.registerForm.controls['partner']['controls']['is_professional'].value) : this.registerForm.controls['profile']['controls']['is_professional'].value;
    const acepted_term = this.selectedRegistrationType == TypeRegistration.Provider ? (this.showFormIntegrator ? this.registerForm.controls['address']['controls']['acepted_term'].value : this.registerForm.controls['partner']['controls']['acepted_term'].value) : this.registerForm.controls['address']['controls']['acepted_term'].value;
    const email = this.registerForm.controls['profile']['controls']['email'].value;
    const phone = this.registerForm.controls['profile']['controls']['phone'].value;
    const zip_code = this.registerForm.controls['address']['controls']['zip_code'].value;
    const address = this.registerForm.controls['address']['controls']['address'].value;
    const number = this.registerForm.controls['address']['controls']['number'].value;
    const neighborhood = this.registerForm.controls['address']['controls']['neighborhood'].value;
    const city = this.registerForm.controls['address']['controls']['city'].value;
    const state = this.registerForm.controls['address']['controls']['state'].value;
    const password = this.registerForm.controls['password']['controls']['password'].value;
    const broker = this.showFormIntegrator ? this.registerForm.controls['profile']['controls']['broker'].value : this._configService.getBroker();
    let birth_date = this.selectedRegistrationType === TypeRegistration.Provider ? (this.showFormIntegrator ? this.registerForm.controls['profile']['controls']['birth_date'].value : null) : this.registerForm.controls['profile']['controls']['birth_date'].value;
    if (birth_date) {
      birth_date = birth_date.toISOString('DD/MM/YYYY');
    }

    if (this.selectedRegistrationType === TypeRegistration.Provider && !this.showFormIntegrator) {
      return {
        name: name,
        cpf: cpf,
        account: account,
        professional: professional || false,
        acepted_term: acepted_term
      };
    }

    return {
      username: email,
      password: password,
      full_name: name,
      email: email,
      broker: broker === 'CEDRO' ? '' : broker,
      document: cpf ? cpf.replace(/\D/g, '') : '',
      phone_number: phone ? phone.replace(/\D/g, '') : '',
      cell_number: '',
      professional_investor_verified: professional || false,
      accepted_term_verified: acepted_term,
      birthdate: birth_date,
      address: {
        street_address: `${address};;${number};;;;${neighborhood}`,
        locality: city,
        region: state,
        postal_code: zip_code ? zip_code.replace(/\D/g, '') : '',
        country: 'BR'
      },
      accounts: []
    };
  }

  submit() {
    this.setDefaultErrorInfo();
    const objToPost = this.parseToPost();
    this.currentStep = StepEnum.FinalLoading;
    const broker = this.showFormIntegrator ? this.registerForm.controls['profile']['controls']['broker'].value : this.registerForm.controls['partner']['controls']['broker'].value;
    this.registerService.registerClient(objToPost, broker)
      .subscribe((response: any) => {
        setTimeout(() => {
          if (response && !response['error'] && response._isScalar !== false) {
            this.router.navigate([!this.isRanking ? '/register/completed' : '/ciclo-investimentos/register/completed']);
          } else {
            if (this.selectedRegistrationType == TypeRegistration.Provider) {
              this.errorTitle = this.errorTypes[1].title;
              this.errorDescription = this.errorTypes[1].description;
              this.errorRetryBtnText = this.errorTypes[1].retryText;
            } else if (response && response['error'] && response['errors'] && response['errors'].length > 0) {
              this.errorDescription = '';
              let length = response['errors'].length;
              response['errors'].forEach(element => {
                this.errorDescription += element.message;
                if (length > 1) {
                  this.errorDescription += ' ';
                  length--;
                }
              });
            } else if (response && response['error'] && response['error_info'] && response['error_info'].length > 0) {
              this.errorDescription = '';
              let length = response['error_info'].length;
              response['error_info'].forEach(element => {
                if (element.details) {
                  this.errorDescription += element.details;
                } else if (element.message) {
                  this.errorDescription += element.message;
                }
                if (length > 1) {
                  this.errorDescription += ' ';
                  length--;
                }
              });
            }
            this.showingError = true;
          }
        }, 5000);
      }, errorResponse => {
        // TODO: Solução paleativa, aguardando o OMS ajustar o erro no Cadastro da TORO
        if (this.selectedBroker && this.selectedBroker.broker.toString().toUpperCase() === 'TOROFAST') {
          this.router.navigate([!this.isRanking ? '/register/completed' : '/ciclo-investimentos/register/completed'], { queryParams: { personMsg: true } });
          return;
        }
        const errorObj = errorResponse.error;
        const errorList = (errorObj && errorObj.error) ? errorObj.error_info : null;
        if (errorList && errorList.length > 0) {
          const invalidPasswordError = errorList.find(e => e.message === 'invalid_password' && e.details);
          if (invalidPasswordError) {
            this.currentStep = StepEnum.Password;
            setTimeout(() => {
              this._snackBar.createEndlessSnack(
                this.snackBarSlot,
                invalidPasswordError.details,
                Constants.ALERT_TYPE.error,
                { absolutePosition: false }
              );
            }, 500);
            return;
          }
        }

        this.showingError = true;
      });
  }

  getProgressBarPercent() {
    const requiredItens = this.selectedRegistrationType === TypeRegistration.Provider ? (this.showFormIntegrator ? ProgressBarMaxEnum.MercBitcoin : ProgressBarMaxEnum.Broker) : ProgressBarMaxEnum.Personal;
    const invalidItens = this.findInvalidControlsRecursive(this.registerForm);
    const valueProgress = (invalidItens <= 0 ? requiredItens : requiredItens - invalidItens) * (100 / requiredItens);
    return valueProgress >= 0 ? valueProgress : 0;
  }

  findInvalidControlsRecursive(formToInvestigate: FormGroup | FormArray): number {
    const invalidControls: string[] = [];
    const recursiveFunc = (form: FormGroup | FormArray) => {
      Object.keys(form.controls).forEach(field => {
        const control = form.get(field);
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        } else {
          if (this.currentStep === StepEnum.PartnerBrokerage) {
            if (control.invalid && field != 'birth_date') { invalidControls.push(field); }
          } else {
            if (control.invalid || (control.disabled && field != 'number') || (field === 'birth_date' && control.value === null)) { invalidControls.push(field); }
          }
        }
      });
    };
    recursiveFunc(formToInvestigate);
    return invalidControls.length;
  }

  onBrokerChange(event) {
    let showFormIntegratorTemp = false;
    this.brokeragePartners.forEach(item => {
      if (item && item.broker && (event.value && item.broker.toUpperCase() === event.value.toUpperCase())) {
        this.selectedBroker = item;
        if (item.broker.toString().toLowerCase() === 'mercbitcoin') {
          // TODO: Se broker igual BITCOIN exibr o formulario sem conta
          showFormIntegratorTemp = true;
        }
        return;
      }
    });
    this.showFormIntegrator = showFormIntegratorTemp ? true : false;
    if (this.showFormIntegrator) {
      this.currentStep = StepEnum.PersonalInformation;
      this.selectType(TypeRegistration.Provider, this.showFormIntegrator);
    } else {
      this.selectType(TypeRegistration.Provider);
      this.currentStep = StepEnum.PartnerBrokerage;
      const profileForm = this.registerForm.get('profile');
      const broker = profileForm.get('broker');
      this.setPartnerRequired(true, broker);
    }
    this.brokerHasSinacor = this.selectedBroker && this.selectedBroker.sinacor;
    this.sinacorErrorTitle = !this.selectedBroker || !this.selectedBroker.broker ? null :
      SINACOR_ERROR_REGISTER_MESSAGE[this.selectedBroker.broker] ? SINACOR_ERROR_REGISTER_MESSAGE[this.selectedBroker.broker].title :
        SINACOR_ERROR_REGISTER_MESSAGE_TITLE_DEFAULT;
    this.sinacorErrorDescription = !this.selectedBroker || !this.selectedBroker.broker ? null :
      SINACOR_ERROR_REGISTER_MESSAGE[this.selectedBroker.broker] ? SINACOR_ERROR_REGISTER_MESSAGE[this.selectedBroker.broker].description :
        SINACOR_ERROR_REGISTER_MESSAGE_DESCRIPTION_DEFAULT;
    this.loadingBrokers = false;
  }

}
